import { ClientScopeProvider, useClientId } from "@/features/utils/api-scope";
import { DashboardOverview } from "@/views/backoffice/dashboard";
import {
  DateRangeSelector,
  type DateRangeOption,
} from "@/views/backoffice/dashboard/components/date-range-selector";
import { useState } from "react";

/**
 * The client's own dashboard — the very component its home page mounts — read
 * through the staff mount, and read only: the recent contacts lose their edit
 * and delete actions, the links lead to this file's calls tab.
 *
 * It is the tab sales open first: the figures the client sees when they log in,
 * without asking them for a screen share.
 */
export function ClientDashboardTab() {
  const clientId = useClientId();
  const [dateRange, setDateRange] = useState<DateRangeOption>("30d");

  return (
    <ClientScopeProvider clientId={clientId} scope="staff" readOnly>
      <div className="space-y-4">
        <div className="flex justify-end">
          <DateRangeSelector value={dateRange} onChange={setDateRange} />
        </div>
        <DashboardOverview dateRange={dateRange} />
      </div>
    </ClientScopeProvider>
  );
}
